<template>
  <div class="p-2 grey lighten-3" style="font-size: 14px">
    <div>
      <span>
        <span class="bolder indigo-text"><mdb-icon  icon="user-alt" /> {{student.name}}</span>
        <mdb-icon  icon="mobile-alt" class="ml-3"/> {{$cellPhone(student.cellPhone)}}
        <mdb-icon far icon="envelope"  class="ml-3"/> {{student.email}}
      </span>
    </div>
    <div>
      <mdb-icon  icon="map-marker-alt" /> {{student.address}}
    </div>
  </div>
</template>
<script>
import {} from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'StaffStudentBasicInfo',
  components: { },
  props: ['student']
}
</script>
